import LoginView from './Login';

export default LoginView;
